import { ParentTree, TrackedState, TreeDetails } from '@holmescorp/lcc-interfaces';
import { userstore } from '../base';
import { rollupStatus } from './rollup-status';

const is_Topicset = (key: string | null, status: ParentTree): boolean => {
	if (key === null) {
		return false;
	}
	const { parent } = status[key];
	if (parent) {
		return !parent.startsWith('topic');
	}
	return false;
};

const is_Topicgroup = (key: string | null, status: ParentTree): boolean => {
	if (key === null) {
		return false;
	}
	const { parent } = status[key];
	return is_Topicset(parent, status);
};

const is_child = (tg: string, key: string | null, status: ParentTree): boolean => {
	if (key === null) {
		return false;
	}
	const { parent } = status[key];
	return parent === tg;
};

export const tgKidMap: { [key: string]: string[] } = {};

function topicGroupChildTree(): void {
	const { get, path } = userstore;
	const status = get(path('status'));
	const topicgroups: string[] = Object.keys(status)
		.map((k) => {
			return is_Topicgroup(k, status) ? k : undefined;
		})
		.filter((v) => {
			return v !== undefined;
		}) as string[];
	topicgroups.forEach((tg) => {
		tgKidMap[tg] = [];
		Object.keys(status).forEach((k) => {
			if (is_child(tg, k, status)) {
				tgKidMap[tg].push(k);
			}
		});
	});
}

export function rolldownGotit(tgkey: string, newvals: TrackedState): void {
	if (Object.keys(tgKidMap).length === 0) {
		topicGroupChildTree();
	}
	const tgkids = tgKidMap[tgkey];
	const { get, path } = userstore;
	const status = get(path('status'));
	const { complete } = newvals;
	tgkids.forEach((key: string) => {
		const item = status[key];
		const { data } = item;
		const { pointscorrect, pointsincorrect, percent, total, readtime } = data;
		const newdata: TrackedState = {
			complete,
			pointscorrect,
			pointsincorrect,
			percent,
			total,
			readtime
		};
		rollupStatus(key, newdata);
	});
}
